<template>
<div class="Copyright">
  <div class="container-fluid">
      <div>	&copy; {{copyright}}</div>
  </div>
</div>
  
</template>
<script>
export default {
  data: function () {
    return {
      copyright: '2024 Mentora Institute. All rights reserved.'
    }
  },
  components: {

  },
  name: 'UserActivityFilterBar'
}
</script>

<style scoped>
.Copyright{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.font-size-20px
{
  font-size:20px;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.margin-Top-5Perc{
  margin-top: 5% !important;
}
.margin-left-1Perc{
  margin-left: 1% !important;
}
.padding-bottom-0Perc{
  padding-bottom: 0px; 
}

</style>


// WEBPACK FOOTER //
// src/components/CopyrightElement.vue